import React, { useMemo, useState } from "react";
import { CheckOutlined, LoadingOutlined, SearchOutlined } from "@ant-design/icons";
import { useTranslation } from "contexts/TranslationContext";
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import BackButton from 'shared/components/BackButton/BackButton';
import routes, { appRoute } from 'shared/constants/routes';
import { Row, Col, Card, Button, Upload, Input, Form, Typography } from "antd";
import { toast } from "react-toastify";
import axios from "axios";


const SheriZeroMerchants = () => {
    const navigate = useNavigate();
    const { translate, language } = useTranslation();
    const [merchants, setMerchants] = useState([]);
    const [visibleCount, setVisibleCount] = useState(24);
    const [searchTerm, setSearchTerm] = useState("");

    const isArabic = language?.code === "ar" ? true : false;

    const extractName = (name, withExtension) => {
        if (!name) return '';
        // Remove leading slash and split by '/'
        const parts = name.replace(/^\//, '').split('/');
        // Get last part (e.g. '{some arabi name}.png' or '.jpg')
        const last = parts[parts.length - 1] || '';
        if (!withExtension)
            return last.replace(/\.(png|jpg|webp)$/i, '');
        else
            return last;
        // Remove .png or .jpg extension (case-insensitive)
    };


    useEffect(() => {
        const fetchMerchants = async () => {
            try {
                await getMerchants();
            } catch (error) {
                console.error('Error fetching merchants:', error);
                toast.error("Something went wrong while fetching merchants. Please try again.");
            }
        };
        fetchMerchants();
    }, [])



    const getMerchants = async () => {
        try {
            const response = await axios.get('https://objectstorage.me-jeddah-1.oraclecloud.com/n/axx0kq2zujnb/b/resal/o/');
            if (!response?.status === 200) {
                throw new Error('Failed to fetch merchants with response status==', response.status);
            }
            // const data = await response.json();
            if (response?.data) {
                setMerchants(response?.data?.objects?.slice(1)); //slicing cus the first index is /arabic only
            }
        } catch (error) {
            console.error('Error fetching merchants:', error);
            toast.error("Something went wrong while fetching merchants. Please try again.");
        }
    }

    const handleLoadMore = () => setVisibleCount(prev => prev + 24);

    const normalize = (text) => {
       return extractName(text)?.toLowerCase().trim() || '';
    }

    const normalizedSearch = normalize(searchTerm);

    const filteredMerchants = !normalizedSearch
        ? merchants
        : merchants.filter((item) => {
            return (
                normalize(item?.name).includes(normalizedSearch)
                // ||
                // normalize(item?.titleEn).includes(normalizedSearch) ||
                // normalize(item?.titleAr).includes(normalizedSearch)
            );
        });

    return (
        <div className="rounded-xl mb-4 px-4 py-4 bg-white shadow-lg">
            <div className="flex justify-between items-center mb-4">
                <BackButton onClick={() => navigate(-1)} />
                <h2 className="text-2xl font-semibold">{translate('MERCHANTS.ALL_CARDS')}</h2>
                <div></div>
            </div>

            <div className="mb-4 flex justify-center">
                {isArabic ?
                    <div className="relative w-4/5">
                        <SearchOutlined className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-500" size={20} />
                        <input
                            type="text"
                            placeholder={translate('MERCHANTS.SEARCH_BY_NAME')}
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setVisibleCount(24); // reset view count on new search
                            }}
                            className="w-full p-3 pr-12 border rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div> :
                    <div className="relative w-4/5">
                        <SearchOutlined className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500" size={20} />
                        <input
                            type="text"
                            placeholder={translate('MERCHANTS.SEARCH_BY_NAME')}
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setVisibleCount(24); // reset view count on new search
                            }}
                            className="w-full p-3 pl-12 border rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>
                }
            </div>

            {/* {
                !searchTerm &&
                <div className="mt-8">
                    <h2 className="text-xl font-semibold">{translate('MERCHANTS.BEST_SELLERS')}</h2>
                    <div></div>
                    <Row gutter={[32, 32]} className="mt-2">
                        {BestSellerimgPath.map((item, index) => (
                            <Col span={6} key={index} xs={12} sm={12} md={6} >
                                <Card className="relative flex flex-col h-full p-4 md:p-5 rounded-xl"
                                    cover={
                                        <img alt={item.name} src={item.path} className="position: absolute; height: 100%; width: 100%; inset: 0px; color: transparent;"
                                            style={{ width: '100%', objectFit: 'contain' }} />
                                    }
                                >
                                    <Card.Meta title={item.name} />
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </div>
            } */}

            <div className="mt-8">
                <h2 className="text-xl font-semibold">{translate('MERCHANTS.PROVIDERS')}</h2>
                <div></div>
                <Row dir="rtl" gutter={[32, 32]} className="mt-2">
                    {merchants.length !== 0 &&
                        filteredMerchants.slice(0, visibleCount).map((item, index) => (
                            <Col span={8} key={index}
                                xs={12}
                                sm={12}
                                md={8}
                            >
                                <Card id={item?.id} className="relative flex flex-col h-full p-4 md:p-5 rounded-xl"
                                    cover={
                                        <img alt={extractName(item?.name)}
                                            src={`https://objectstorage.me-jeddah-1.oraclecloud.com/n/axx0kq2zujnb/b/resal/o/arabic/${extractName(item?.name, true)}`}
                                            className="position: absolute; height:200px; width: 100%; inset: 0px; color: transparent;"
                                            style={{ width: '400px', objectFit: 'contain', height: '200px' }} />
                                    }
                                >
                                    <Card.Meta style={{ textAlign: 'center' }} title={extractName(item?.name)} />
                                </Card>
                            </Col>
                        ))
                    }
                </Row>

                {visibleCount < merchants.length && (
                    <div className="flex justify-center mt-6">
                        <button
                            onClick={handleLoadMore}
                            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-xl shadow transition w-72 p-10"
                        >
                            Load More
                        </button>
                    </div>
                )}
            </div>
        </div >
    )

}

export default SheriZeroMerchants;